import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { plantProfileQueryOptions } from './plant-profile.query-options';

/**
 * 발전소 프로필(정보 상세) query — `plantProfileQueryOptions`(entity SSOT)를 컨텍스트에 적용. app-legacy(v3).
 * plantId 없으면 미조회(enabled=false).
 */
export function usePlantProfileQuery(plantId: string) {
  const api = useApiAppLegacy();
  return useQuery({ ...plantProfileQueryOptions(api, plantId), enabled: Boolean(plantId) });
}
